import type { EvaluationEnvelope } from "@/types/evaluation";

// --- KPIs para "Informes consolidados" (5 métricas agregadas de todo el rango) ---
export type KpiResult = {
  total: number;
  aptos: number;
  enGestion: number;
  noAptos: number;
  reprogramados: number;
};

const norm = (v: unknown) => String(v || "").toUpperCase().trim();

export function computeKpis(evaluations: EvaluationEnvelope[]): KpiResult {
  const result: KpiResult = { total: 0, aptos: 0, enGestion: 0, noAptos: 0, reprogramados: 0 };
  for (const e of evaluations) {
    result.total++;
    const action = norm(e.accionFinal);
    const status = norm(e.estadoAdministrativo);
    const clinical = norm(e.resultadoClinico);
    if (action.includes("APTO") && !action.includes("NO")) result.aptos++;
    else if (action.includes("EN GESTI") || status.includes("EN GESTI") || clinical.includes("EN GESTI")) result.enGestion++;
    else if (action.includes("REPROGRAM") || clinical.includes("REPROGRAM")) result.reprogramados++;
    else if (action.includes("NO APTO") || action.includes("NO SUBSAN") || status.includes("NO SUBSAN")) result.noAptos++;
  }
  return result;
}

// --- KPIs para Dashboard rico (5 tiles con iconos, foco en HOY) ---
export type DashboardKpiResult = {
  pendientes: number;
  valoradosHoy: number;
  aptosHoy: number;
  reprogClinica: number;
  reprogAdmin: number;
};

const trim = (v: unknown) => String(v || "").trim();

export function computeDashboardKpis(
  evaluations: EvaluationEnvelope[],
  pendientesTotal: number,
  todayIso: string,
): DashboardKpiResult {
  const hoyVals = evaluations.filter((e) => trim(e.fechaRegistro) === todayIso);
  let aptosHoy = 0, reprogClinica = 0, reprogAdmin = 0;
  for (const v of hoyVals) {
    const a = trim(v.accionFinal);
    if (a === "Apto") aptosHoy++;
    else if (a === "Reprogramar por causa clínica") reprogClinica++;
    else if (a === "Reprogramar por causa administrativa") reprogAdmin++;
  }
  return {
    pendientes: pendientesTotal,
    valoradosHoy: hoyVals.length,
    aptosHoy,
    reprogClinica,
    reprogAdmin,
  };
}
